const Footer = () => {
    return (
        <div className="footer">
            <ul className="footer-ul">
                <li>Who We Are</li>
                <li>Blog</li>
                <li>Work With Us</li>
                <li>Investor Relations</li>
                <li>Report Fraud</li>
                <li>Contact Us</li>
            </ul>
            <h3 className="footer-heading">@2024 Media Public Lim.</h3>
            <div>
                <img className="footer-img" src='https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png' />
                <img className="footer-img" src='https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png' />
                <img className="footer-img" src='https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Whatsapp2_colored_svg-512.png' />
            </div>
        </div>
    )
}
export default Footer